import { render } from "./MatriculasV2Embed.vue?vue&type=template&id=097bfd5e&scoped=true"
import script from "./MatriculasV2Embed.vue?vue&type=script&lang=js"
export * from "./MatriculasV2Embed.vue?vue&type=script&lang=js"

import "./MatriculasV2Embed.vue?vue&type=style&index=0&id=097bfd5e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097bfd5e"]])

export default __exports__